export default "__VITE_ASSET__7715db34__"